// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Gugjg","header":"Section_header__CY-C9","count":"Section_count__HgA+Q","expand":"Section_expand__kahUP","fieldsWrapper":"Section_fieldsWrapper__PzPlm"};